var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { Grid, Typography } from '@mui/material';
import { useRequest } from '../../../hooks/requestHook';
import { useNotify } from '../../../hooks/notificationHook';
import { useSampleOrderListItem } from '../../../hooks/useListItem';
import { useConfirm } from '../../../hooks/confirmationHook';
import { sampleOrder as api } from '../../../api';
import { camelize } from '../../../utils/camelize';
import { OrderFieldFormats } from '../../../constants/fieldFormats';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import { FormikSelectField } from '../../atoms/SelectField';
import { FormikTextField } from '../../atoms/TextField';
import FormikSelectCountryCallingCodeField from '../../atoms/FormikSelectCountryCallingCodeField';
import OfferListLinks from '../../molecules/OfferListLinks';
var REQUIRED_FIELDS = [
    'person_name',
    'postal_code',
    'prefecture',
    'city',
    'address',
    'phone',
    'country_calling_code',
    'email',
    'status',
];
var toFormValues = function (order) { return ({
    store_name: order.storeName,
    person_name: order.personName,
    name_kana: order.nameKana,
    postal_code: order.postalCode,
    prefecture: order.prefecture,
    city: order.city,
    address: order.address,
    building: order.building,
    phone: order.phone,
    country_calling_code: order.countryCallingCode,
    email: order.email,
    status: order.status,
    delivery_company: order.deliveryCompany,
    tracking_url: order.trackingUrl,
    tracking_number: order.trackingNumber,
    eori_number: order.eoriNumber,
}); };
var GridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"], ["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"])));
var SampleOrderForm = function (_a) {
    var sampleOrder = _a.sampleOrder, items = _a.items, editable = _a.editable, onSampleOrderChanged = _a.onSampleOrderChanged;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var statusItems = useSampleOrderListItem().statusItems;
    var confirm = useConfirm();
    var update = useRequest(api.update);
    var navigate = useNavigate();
    var asyncUpdate = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, update({
                            id: sampleOrder.id,
                            sample_order: values,
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/, false];
                    onSampleOrderChanged(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/, true];
            }
        });
    }); }, [setLoading, update, notify, t, sampleOrder.id, onSampleOrderChanged]);
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (values.status === 'canceled') {
                        confirm(t('confirmTitle'), t('messages.cancelConfirm'), function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, asyncUpdate(values)];
                                    case 1:
                                        _a.sent();
                                        navigate(-1);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, asyncUpdate(values)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [t, asyncUpdate, confirm, navigate]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.order.".concat(camelize(field))),
                });
            }
        });
        Object.entries(OrderFieldFormats).forEach(function (_a) {
            var field = _a[0], regExp = _a[1];
            var fieldAsKey = field;
            var value = values[fieldAsKey];
            if (typeof value === 'string' && !regExp.test(value)) {
                errors[fieldAsKey] = t('errors.invalid', {
                    field: t("params.order.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: toFormValues(sampleOrder),
        onSubmit: onSubmit,
        validateOnMount: true,
        validateOnChange: true,
        validateOnBlur: true,
        validate: validate,
        enableReinitialize: true,
    });
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(GridContainer, { container: true, spacing: 4 },
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('params.offerList.name'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                React.createElement(OfferListLinks, { offerLists: sampleOrder.offerLists, pathPrefix: "/admin" })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('params.roaster.name'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 }, t('fullname', sampleOrder.roaster)),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('pages.sampleOrderDetail.requestedLotNumbers'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 }, items.map(function (item) { return item.offer.lotNumber; }).join(',')),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikSelectField, { fullWidth: true, label: t('params.order.status'), name: "status", items: statusItems, required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "store_name", label: t('params.order.storeName'), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "person_name", label: t('params.order.personName'), disabled: !editable, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "name_kana", label: t("params.order.nameKana"), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "postal_code", inputProps: { maxLength: 9 }, label: t('params.order.postalCode'), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "prefecture", label: t("params.order.prefecture"), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "city", label: t("params.order.city"), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "address", label: t("params.order.address"), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "building", label: t('params.order.building'), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 2 },
                React.createElement(FormikSelectCountryCallingCodeField, { name: "country_calling_code", label: t('params.sampleOrder.countryCallingCode'), disabled: !editable, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikTextField, { fullWidth: true, name: "phone", label: t('params.order.phone'), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "email", label: t('params.order.email'), required: true, disabled: !editable, formik: formik })),
            sampleOrder.roaster.country.eoriNumberEnabled && (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "eori_number", label: t('params.eoriNumber'), disabled: !editable, formik: formik }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "delivery_company", label: t('params.deliveryCompany'), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "tracking_number", label: t('params.trackingNumber'), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "tracking_url", label: t('params.trackingUrl'), disabled: !editable, formik: formik })),
            editable && (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PageSubmitButton, { disabled: loading || !formik.isValid }, t('buttons.update')))))));
};
export default SampleOrderForm;
var templateObject_1;
